import Vue from 'vue'
import DragAndDrop from 'vue-drag-and-drop'
import iView from 'iview'
import taskList from 'hexyun-task-list'
import './assets/iview/iview.css';
// import 'packages/themes/wuwei/index.less'
import wuwei from '../packages/index.js'
import './utils/filters.js'
import $ from 'jquery'
window.jQuery = $;
window.$ = $;
import './libs/cache'
import './assets/font-awesome/css/font-awesome.min.css'
import './assets/common.css'

import App from './App.vue'
import router from './router/index'
import loading from './components/editor/loading/index.vue'
import global_ from './global.js'
var VueCodeMirror = require('vue-codemirror-lite')

Vue.use(VueCodeMirror)
// import 'codemirror/theme/monokai.css'
require("codemirror/mode/javascript/javascript");
require("codemirror/mode/vue/vue");

require("codemirror/addon/hint/show-hint.js");
require("codemirror/addon/hint/show-hint.css");
require("codemirror/addon/hint/javascript-hint.js");
require("codemirror/addon/hint/html-hint.js");
require("codemirror/addon/hint/css-hint.js");
Vue.use(DragAndDrop);
Vue.use(iView);
Vue.use(wuwei);
Vue.use(taskList);
// 必须放在ivew之后
import http from './libs/http';

window.log = item => console.log(item);

function _report(errorObj) {
  Vue.prototype.$$post('/api/front/errorParser', errorObj).then(ret => {
    console.log('ret', ret)
    let data = ret
    for (let k in data) {
      data[k] = `${data[k]}`
    }
    Vue.prototype.$report(data)
  })
}

// 资源加载上报
window.addEventListener('error', function _resourceError(e) {
  var target = e.target ? e.target : e.srcElement
  var options = {}
  options.message = e.target.localName + ' is load error'
  options.stack = 'resouce is not found'
  options.tagName = e.target.localName
  options.html = target.outerHTML
  options.errorType = e.type
  options.fileName = e.target.currentSrc
  options.category = 'resource'
  if (e.target !== window) {
    // 抛去js语法错误
    // 合并上报的数据，包括默认上报的数据和自定义上报的数据
    setTimeout(_ => Vue.prototype.$report(options), 0)
  }
}, true)
// js 上报
window.onerror = function _onerror(message, script, line, column, error) {
  if (message === 'Script error.' && !script) {
    return false
  }
  // 构建错误对象
  var o = {
    script,
    type: 'editor',
    from: 'global',
    name: error.name || '',
    message,
    line,
    col: column || (window.event && window.event.errorCharacter) || 0,
    stack: error && error.stack ? error.stack : null
  }

  if (!o.line) {
    let r = parseErrorStack(o.stack)
    if (r.length) {
      o.line = r[0].line
      o.script = r[0].file
      o.code = r[0].code
      o.col = r[0].col
    }
  }
  setTimeout(_ => _report(o), 0)
}

function parseErrorStack(message) {
  let files = message.split(/\bat/g)
  let r = []
  function _process(l) {
    const result = l.split(/[\s\t\r\n()]+/g)
    console.log(result)
    let [code, file] = result
    file = file.split(':')
    let col = file.pop()
    let line = file.pop()
    file = file.join(':')
    console.log({ code, file, line, col })
    return { code, file, line, col }
  }
  for (let i = 1; i < files.length; i++) {
    r.push(_process(files[i].trim()))
  }
  return r
}
Vue.prototype.GLOBAL = global_

const logger = new window.Tracker(global_.tracker.host, global_.tracker.project, global_.tracker.logstroe)
Vue.prototype.getQuery = function () {
  function getQuery(url) {
    var query = {}
    var arr = url.split('#!/')[1].split(/[&=/?]/)
    for (let i = 0; i < arr.length; i += 2) {
      if (arr[i][0] === '?') arr[i] = arr[i].slice(1)
      query[arr[i]] = arr[i + 1]
    }
    return query
  }
  return getQuery(window.location.href)
}
Vue.prototype.$event = new Vue()
Vue.prototype.sendLogger = function (data) {
  function getQuery(url) {
    var query = {}
    var arr = url.split('#!/')[1].split(/[&=/?]/)
    for (let i = 0; i < arr.length; i += 2) {
      if (arr[i][0] === '?') arr[i] = arr[i].slice(1)
      query[arr[i]] = arr[i + 1]
    }
    return query
  }
  const userInfo = JSON.parse(window.localStorage.getItem('editorLogInfo'))
  const url = window.location.href
  const data_id = new Date().getTime() + Math.random().toString().slice(-6)
  const query = getQuery(url)
  if (!query.project_id) {
    const pro = JSON.parse(window.localStorage.getItem('selectProject'))
    query.project_id = pro && pro.project_id
  }
  const project_id = query.project_id || ''
  const app_id = query.editor || ''
  const page_id = query.panel || query.flow || ''
  const func_id = query.function_id || data.func_id
  const info = {
    data_id,
    url,
    user_id: userInfo && userInfo._id,
    project_id,
    app_id,
    page_id,
    func_id
  }
  const tar = JSON.stringify(Object.assign(info, data))
  logger.push('data', tar)
  logger.logger()
}

var EnvironmentalUrl = window.location.href.split("#")[0]
switch (EnvironmentalUrl) {
  case 'https://editor.preview.lowcode.com/':
    window.figureOpenUrl = 'https://13000.preview.lowcode.com/'
    window.technologyOpenUrl = 'https://wuwei.preview.lowcode.com/'
    break;
  case 'https://editor.wuwei.wudaima.com/':
    window.figureOpenUrl = 'https://dev.wuwei.wudaima.com/'
    window.technologyOpenUrl = 'https://13000.wuwei.wudaima.com/'
    break;
  case 'https://editor.jc.wudaima.com/':
    window.figureOpenUrl = 'https://dev.jc.wudaima.com/'
    window.technologyOpenUrl = 'https://14000.jc.wudaima.com/'
    break;
  default:
    window.figureOpenUrl = 'https://wuwei.wudaima.com/'
    window.technologyOpenUrl = 'https://wuwei-inner.wudaima.com/'
    break;
}
// 实例化入口组件
router.start(App, 'app')



// WEBPACK FOOTER //
// ./src/main.js